import { handleError } from "../../../utils/helpers";
import { QueryParams } from "../../../utils/types";
import { baseApi } from "../../api";
import {
  BankListResponse,
  PayoutAccountPayload,
  PayoutAccountResponse,
  PayoutDetailsResponse,
  PayoutHistoryResponse,
  PurchaseStatisticsResponse,
  ResolveAccountPayload,
  ResolveAccountResponse,
} from "./payment.types";

export const paymentApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    addPayoutAccount: builder.mutation<
      PayoutAccountResponse,
      PayoutAccountPayload
    >({
      query: (payload) => {
        return {
          url: "payments/payout-account",
          method: "POST",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, true);
        }
      },
    }),
    updatePayoutAccount: builder.mutation<
      PayoutAccountResponse,
      PayoutAccountPayload
    >({
      query: (payload) => {
        return {
          url: "payments/payout-account",
          method: "PATCH",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, true);
        }
      },
    }),
    getPayoutAccount: builder.query<PayoutAccountResponse, {}>({
      query: (params) => {
        return {
          url: "payments/payout-account/details",
          method: "GET",
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    getBankList: builder.query<BankListResponse, {}>({
      query: (params) => {
        return {
          url: "payments/banks",
          method: "GET",
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    resolveAccountDetails: builder.mutation<
      ResolveAccountResponse,
      ResolveAccountPayload
    >({
      query: (payload) => {
        return {
          url: "payments/resolve-account",
          method: "POST",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, false);
        }
      },
    }),
    getPurchaseStatistics: builder.query<
      PurchaseStatisticsResponse,
      { eventId: string; otherParams?: QueryParams }
    >({
      query: (params) => {
        return {
          url: `payments/summary/${params.eventId}`,
          method: "GET",
          params: params.otherParams,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    getPayoutHistory: builder.query<
      PayoutHistoryResponse,
      { eventId: string; otherParams?: QueryParams }
    >({
      query: (params) => {
        return {
          url: `payments/${params.eventId}/payout-history`,
          method: "GET",
          params: params.otherParams,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    getSinglePayoutDetails: builder.query<
      PayoutDetailsResponse,
      { id: string }
    >({
      query: (params) => {
        return {
          url: `payments/${params.id}/payout-details`,
          method: "GET",
          params: {},
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
  }),
});

export const {
  useAddPayoutAccountMutation,
  useUpdatePayoutAccountMutation,
  useGetPayoutAccountQuery,
  useGetBankListQuery,
  useResolveAccountDetailsMutation,
  useGetPurchaseStatisticsQuery,
  useGetPayoutHistoryQuery,
  useGetSinglePayoutDetailsQuery,
} = paymentApi;
